import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const shippingType = v.union(
  v.literal("sea"),
  v.literal("air"),
  v.literal("land"),
);

export const calendarFrequency = v.union(
  v.literal("weekly"),
  v.literal("biweekly"),
  v.literal("monthly"),
  v.literal("custom"),
);

export const autoCreateTrigger = v.union(
  v.literal("on_previous_closed"),
  v.literal("manual_only"),
);

export const validatorConsolidationCalendar = v.object({
  name: v.string(),
  shippingType,
  frequency: calendarFrequency,
  customDays: v.optional(v.number()),
  cutoffDay: v.optional(v.number()),
  departureDays: v.optional(v.array(v.number())),
  transitDays: v.optional(v.number()),
  defaultRouteId: v.optional(v.id("shipping_routes")),
  defaultCarrierId: v.optional(v.id("carriers")),
  defaultContainerId: v.id("containers"),
  warningThresholdPercent: v.number(),
  autoCreateShipment: v.optional(v.boolean()),
  autoCreateConsolidado: v.optional(v.boolean()), // Deprecated: use autoCreateShipment
  autoCreateTrigger: v.optional(autoCreateTrigger),
  isActive: v.boolean(),
  internalControl,
});

export const consolidation_calendars = defineTable(
  validatorConsolidationCalendar,
)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ])
  .index("by_shipping_type", ["shippingType"])
  .index("by_is_active", ["isActive"])
  .index("by_company_and_active", ["internalControl.companyId", "isActive"])
  .index("by_company_and_shipping_type", [
    "internalControl.companyId",
    "shippingType",
  ])
  .index("by_default_container", ["defaultContainerId"]);
